import request from '@/utils/request'
import { service1 } from '@/utils/request'
export function apiLogin(data) {
  return request({
    url: '/gangkou/user/login',
    method: 'post',
    data
  })
}

export function apiUserInfo() {
  return request({
    url: 'DM/dmdp-homepage/sync/SyncNews/userInfo.do',
    method: 'get'
  })
}
export function apiLoginOut() {
  return request({
    url: 'DM/dmdp-homepage/sync/SSO/logout.do',
    method: 'get'
  })
}

// 埋点接口
export function pushStatus(status) {
  return request({
    url: `DM/dmdp-homepage/gkdata/GKData/saveVisitLog.do?mCode=${status.m_code}&&userId=${status.userId}`,
    method: 'get',
    status
  })
}
export function getCityUrl(fileName) {
  return request({
    url: `/dmdp-homepage/homepage/item/Sxzq/searchAll.do?csmc=${fileName.csmc}&mkmc=${fileName.mkmc}`,
    method: 'get',
    // data: fileName,
  })
}

export function initHome(data) {
  return service1({
    url: `/service/services/rest/dataServer/request`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js